<template>
    <div id="main_content" style="padding: 230px 0 5rem 0">
        <span class="title" style="margin-right: 70px;"> {{ mode == 'new' ? 'ایجاد یک صفحه جدید' : 'ویرایش صفحه' }}</span>
        <form @submit="onSubmit" class="container" enctype="multipart/form-data">
            <h1 style="margin-bottom: 1rem; width: 100%;">
                <input
                    type="text"
                    class="form-control"
                    placeholder="عنوان صفحه"
                    style="font-size: unset;"
                    id="main_headline"
                    maxlength="255"
                    v-model="mainHeadline"
                    autofocus
                    autocomplete="off"
                >
                <label class="invalid-hint" for="main_headline">عنوان اصلی صفحه الزامی بوده لکن عنوان بلند تر از ۲۵۵ حرف مجاز نیست</label>
            </h1>
            <WYSIWYG v-model:content="content" placeholder="محتوا" id="content" invalid-hint="محتوا الزامی است" />
            <label for="direct_link" style="margin-top: 1rem;">لینک مستقیم صفحه (مثلا <bdo dir="ltr">/notifications/register-rules</bdo>)</label>
            <input type="text" id="direct_link" v-model="directLink" @input="linkInput" @keypress="linkKeypress" class="form-control" style="direction: ltr;" autocomplete="off">
            <label class="invalid-hint" for="direct_link">لینک مستقیم به صفحه الزامی است و باید فقط شامل حروف انگلیسی، اعداد لاتین و کاراکتر هایی مثل - و + و _ باشد</label>
            <div style="margin: 1rem 0; display: flex; width: 100%; flex-flow: row nowrap; justify-content: center;">
                <input type="checkbox" id="enableAlternateLink" v-model="enableAlternateLink" style="margin-left: 0.5rem;">
                <label for="enableAlternateLink">اتصال زیرمنوی مرتبط به لینکی غیر از این صفحه</label>
            </div>
            <br>
            <label v-if="enableAlternateLink" for="alternate_link">لینک اتصال زیرمنو به صفحه ای غیر از این صفحه (مثلا about/)</label>
            <input v-if="enableAlternateLink" type="text" id="alternate_link" v-model="alternateLink" @input="linkInput" @keypress="linkKeypress" class="form-control" style="direction: ltr;" autocomplete="off">
            <label v-if="enableAlternateLink" class="invalid-hint" for="alternate_link">لینک اتصال زیرمنو باید فقط شامل حروف انگلیسی،‌ اعداد لاتین و کاراکتر هایی مثل - و + و _ باشد</label>
            <div style="margin-top: 1rem;">
                <button type="submit" class="btn btn-green" style="float: left;">{{ mode == 'new' ? 'ایجاد' : 'ویرایش' }}</button>
                <button v-if="mode == 'edit'" type="button" @click="$router.go(-1)" class="btn btn-secondary" style="float: left; margin-left: 1rem;">بازگشت</button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import WYSIWYG from '@/components/wysiwyg'
import { Delta } from '@vueup/vue-quill'
import { useRoute, useRouter } from 'vue-router'

const mainHeadline = ref("")
    , content = ref(new Delta)
    , $route = useRoute()
    , $router = useRouter()
    , directLink = ref("/")
    , mode = ref("new")
    , enableAlternateLink = ref(false)
    , alternateLink = ref("/")

function onSubmit($event) {
    $event.preventDefault();
    const values = {
        mainHeadline: mainHeadline.value,
        content: content.value,
        directLink: directLink.value,
        alternateLink: enableAlternateLink.value ? alternateLink.value : null,
        menuID: $route.params.menuID,
    }
    var status = true

    if (!mainHeadlineValidate(values)) { status = false; $('#main_headline').addClass('invalid'); $('label.invalid-hint[for="main_headline"]').addClass('shown'); }
    else { $('#main_headline').removeClass('invalid'); $('label.invalid-hint[for="main_headline"]').removeClass('shown'); }

    if (!contentValidate(values)) { status = false; $('#content').addClass('invalid'); $('span.invalid-hint[for="content"]').addClass('shown'); }
    else { $('#content').removeClass('invalid'); $('span.invalid-hint[for="content"]').removeClass('shown'); }

    if (!directLinkValidate(values)) { status = false; $('#direct_link').addClass('invalid'); $('label.invalid-hint[for="direct_link"]').addClass('shown'); }
    else { $('#direct_link').removeClass('invalid'); $('label.invalid-hint[for="direct_link"]').removeClass('shown'); }

    if (!alternateLinkValidate(values)) { status = false; $('#alternate_link').addClass('invalid'); $('label.invalid-hint[for="alternate_link"]').addClass('shown'); }
    else { $('#alternate_link').removeClass('invalid'); $('label.invalid-hint[for="alternate_link"]').removeClass('shown'); }

    if (mode.value ==  'edit') values.pageID = $route.params.pageID;
    const fd = new FormData;
    for (const key in values) {
        if (Object.hasOwnProperty.call(values, key) && key != 'content') {
            const value = values[key];
            fd.append(key, value)
        }
    }

    fd.append('content', JSON.stringify(values.content.ops))

    if (status) {
        $.ajax({
            url: `${process.env.VUE_APP_SERVER_ROOT}${mode.value == 'new' ? 'new-navbar-item' : 'edit-navbar-item'}`,
            method: "POST",
            xhrFields: { withCredentials: true },
            data: fd,
            dataType: "json",
            contentType: false,
            processData: false,
            success(data) {
                if(data.STATUS) {
                    $router.push(($route.params.locale ? `/${$route.params.locale}` : '') + values.directLink)
                } else {
                    alert(`خطا ${mode.value == 'new' ? 'ایجاد' : 'ویرایش'} صفحه`)
                }
            }
        })
    }
}

function linkInput($event) {
    if ("/" != directLink.value[0]) directLink.value = "/" + directLink.value
    if (/[^a-z0-9\-\_\/\+]/ig.test(directLink.value)) directLink.value = directLink.value.replaceAll(/[^a-z0-9\-\_\/\+]/ig, '')

    if ("/" != alternateLink.value[0]) alternateLink.value = "/" + alternateLink.value
    if (/[^a-z0-9\-\_\/\+]/ig.test(alternateLink.value)) alternateLink.value = alternateLink.value.replaceAll(/[^a-z0-9\-\_\/\+]/ig, '')
}

function linkKeypress($event) {
    if (!/^[a-zA-Z0-9\-\_\/\+]$/.test($event.key)) {
        $event.preventDefault();
        return false;
    }
} 

function mainHeadlineValidate(values) { return values.mainHeadline && values.mainHeadline.length < 256 }
function contentValidate(values)      { return values.content && values.content.length() }
function directLinkValidate(values)   { return values.directLink && /^\/[a-zA-Z0-9\-\_\/\+]+$/.test(values.directLink) }
function alternateLinkValidate(values)   { return values.alternateLink == null || /^\/[a-zA-Z0-9\-\_\/\+]*$/.test(values.alternateLink) }

onMounted(fetchPage)

watch($route, fetchPage)

function fetchPage() {
    if ($route.params.pageID) {
        // ON EDIT PAGE
        mode.value = "edit"
        const pageID = $route.params.pageID
        $.ajax({
            url: `${process.env.VUE_APP_SERVER_ROOT}visit-static-by-id/${pageID}`,
            method: "GET",
            dataType: 'json',
            xhrFields: { withCredentials: true },
            success(data) {
                if (data.STATUS) {
                    mainHeadline.value = data.TITLE
                    content.value = new Delta(data.CONTENT)
                    directLink.value = data.DIRECT_LINK
                    alternateLink.value = data.ALTERNATE_LINK
                    enableAlternateLink.value = !!data.ALTERNATE_LINK
                } else {
                    alert("دریافت اطلاعات موفقیت آمیز نبود زیرا " + data.REASON)
                }
            },
            error() {
                alert('دریافت اطلاعات موفقیت آمیز نبود.')
            }
        })
    }
}

</script>